import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '@components/common/ProtectedRoute';
import { RoleGuard } from '@components/common/RoleGuard';
import { AppLayout } from '@components/layout/AppLayout';
import { LoginPage } from '@features/auth/components/LoginPage';
import { ForgotPasswordPage } from '@features/auth/components/ForgotPasswordPage';
import { ResetPasswordPage } from '@features/auth/components/ResetPasswordPage';
import { CompanySelectorPage } from '@features/companies/components/CompanySelectorPage';
import { DashboardPage } from '@features/dashboard/components/DashboardPage';
import { InvoiceListPage } from '@features/invoices/components/InvoiceListPage';
import { InvoiceWizardPage } from '@features/invoices/components/InvoiceWizardPage';
import { InvoiceDetailPage } from '@features/invoices/components/InvoiceDetailPage';
import { CustomerListPage } from '@features/customers/components/CustomerListPage';
import { ProductListPage } from '@features/products/components/ProductListPage';
import { EditCompanyPage } from '@features/company/components/EditCompanyPage';
import { AdminSettingsPage } from '@features/company/components/AdminSettingsPage';
import { BranchOfficeManagerPage } from '@features/branchOffice/components/BranchOfficeManagerPage';
import { UserManagerPage } from '@features/users/components/UserManagerPage';
import { MainPage } from '@features/home/components/MainPage';
import { MinorPage } from '@features/home/components/MinorPage';
import { ReportsPage } from '@features/reports/components/ReportsPage';
import { PlansPage } from '@features/subscriptions/components/PlansPage';
import { CertificateBundlePage } from '@features/subscriptions/components/CertificateBundlePage';
import { FAQPage } from '@features/faq';
import { UserManualPage } from '@features/manual';
import { ComingSoon } from '@components/common/ComingSoon';


export function AppRoutes() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />

      {/* Protected routes */}
      <Route element={<ProtectedRoute />}>
        {/* Company Selection - outside AppLayout */}
        <Route path="/select-company" element={<CompanySelectorPage />} />

        <Route element={<AppLayout />}>
          <Route element={<RoleGuard />}>
            <Route path="/home/main" element={<MainPage />} />
            <Route path="/home/minor" element={<MinorPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/invoices" element={<InvoiceListPage />} />
            <Route path="/invoices/new" element={<InvoiceWizardPage />} />
            <Route path="/pages/invoice/:id" element={<InvoiceDetailPage />} />
            <Route path="/customers" element={<CustomerListPage />} />
            <Route path="/products" element={<ProductListPage />} />

            {/* Company Routes */}
            <Route path="/company/edit" element={<EditCompanyPage />} />
            <Route path="/company/settings" element={<AdminSettingsPage />} />

            {/* Branch Office Routes */}
            <Route path="/branchoffice/manager" element={<BranchOfficeManagerPage />} />

            {/* User Routes */}
            <Route path="/user/manager" element={<UserManagerPage />} />

            {/* Admin Routes */}
            <Route path="/admin/devtools" element={<ComingSoon title="Herramientas de Desarrollo" description="Las herramientas de desarrollo estarán disponibles próximamente." />} />

            {/* Report Routes */}
            <Route path="/report/reports" element={<ReportsPage />} />

            {/* Subscription Routes */}
            <Route path="/subscriptions/plans" element={<PlansPage />} />
            <Route path="/subscriptions/certificate-bundle" element={<CertificateBundlePage />} />

            {/* FAQ Routes */}
            <Route path="/faq" element={<FAQPage />} />

            {/* Manual Routes */}
            <Route path="/manual" element={<UserManualPage />} />

            {/* Redirect root to home */}
            <Route path="/" element={<Navigate to="/home/main" replace />} />
          </Route>
        </Route>
      </Route>

      {/* Catch all - redirect to login */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
